<template>
	<div class="color-filter">
    <label>{{$_('sort_by')}} : </label>
    <span class="color-name" v-for="(filter, index) in color_filter" :key="index" @click="vColorFilter(filter.TCCOL)">
      <span>{{ filter.TLIB_CCOL }}</span> |
    </span>
    <span class="all-color" @click="vColorFilter('')">{{$_('all')}}</span>  
    <div class="color-code-research">
      <input type="text" @input="vColorFilterCode($event)" :placeholder="$_('filter_by_color_code')" />
    </div>
	</div>
</template>

<script>

import searchService from '@/modules/recherche/services/searchService.js';

export default {
  name: 'ColorFilter',
  data() {
    return {
      color_filter: Array()
    }
  },
  created() {
    searchService.getColor()
    .then(res => {
      if(res.data.DS_O !== undefined) {
        this.color_filter = res.data.DS_O.OUT
      }
    })
  },
  methods: {
    vColorFilter(tccol) {
      this.$store.dispatch('produit/SELECT', {key: 'fgrpcol', value: tccol})
      this.$store.dispatch('produit/LAUNCH_CONFIG')
    },
    vColorFilterCode(event) {
      this.$store.dispatch('produit/COLOR_FILTER_CODE', {color_code: event.target.value});
    }       
  }
}
</script>

<style scoped>
.color-filter {
  margin-top: 25px;
}
.color-name span {
  margin: 10px;
}
.color-name {
  color: #808080;
}
.color-name:hover {
  cursor: pointer;
}
.color-code-research {
  margin-top: 25px;
}
.all-color {
  margin: 10px;
}
</style>